<template>
  <div>
    <PageTitle
      title="Guest View"
      :backBtn="true"
      :editRoute="'edit/' + this.$route.params.id"
      :permission="'User Edit'"
    />

    <v-container fluid>
      <!-- Page Title -->

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
             <v-img v-if="guest.image"    :src="guest.image" height="500"> </v-img>
            <v-img v-else src="../../../assets/profile.jpg" height="350"> </v-img>
            <v-list two-line class="pl-10 pr-10">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-id-card</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Full Name</v-list-item-title
                  >
                  <v-list-item-title>{{ guest.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mail</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Nic Number</v-list-item-title
                  >
                  <v-list-item-title>{{ guest.nic_number }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account-group-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Passport Number</v-list-item-title
                  >
                  <v-list-item-title>
                    {{ guest.passport_number }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
                      <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account-group-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Date of birth</v-list-item-title
                  >
                  <v-list-item-title>
                    {{ guest.date_of_birth | formatDate }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card class="address-card">
            <v-card-title>Contacts</v-card-title>
            <v-list two-line class="pa-0">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-mailbox-open-up</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Phone</v-list-item-sub-title>
                  <v-list-item-title>{{ guest.phone }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-search-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Email</v-list-item-sub-title>
                  <v-list-item-title> {{ guest.email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Address</v-list-item-sub-title>
                  <v-list-item-title>{{ guest.address }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                  <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Company</v-list-item-sub-title>
                  <v-list-item-title>{{ guest.company }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <v-row>
          <v-col>
            <v-card class="lighten-12">
              <v-card-title>Files</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <FileUpload
                      :multiple="true"
                      size="10000"
                      icon="mdi-upload"
                      autoupload="true"
                      :url="'document/upload/guest/' + this.$route.params.id"
                      :showDocumentView="true"
                      :documentsUrl="
                        'document/guest/' + this.$route.params.id
                      "
                      downloadUrl="document/:id/download"
                      removeUrl="document/:id"
                    ></FileUpload>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          </v-row>
         

        </v-col>
     
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-tabs
              v-model="activityTab"
              background-color="white"
              color="primary"
              slider-color="primary"
            >
              <v-tab> Orders </v-tab>
              <v-tab> Reservations </v-tab>
            </v-tabs>
            <v-tabs-items v-model="activityTab">
              <v-tab-item>
                <GuestOrderList />
              </v-tab-item>
              <v-tab-item>
                <GuestReservationList />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import jwt_decode from "jwt-decode";
import { User } from "../../../models/User";
import FileUpload from "@/components/base/FileUpload";
import GuestOrderList from "./GuestOrderList"
import GuestReservationList from "./GuestReservationList"
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    GuestOrderList,
    GuestReservationList
  },
  data: () => ({
    name: "",
    email: "",
    guest: [],
    activityTab: 0,
  }),

  methods: {
    submit() {
      this.$refs.observer.validate();
      this.EditGuest();
    },
    

    getGuest() {
      let guestId = this.$route.params.id;

      this.$store
        .dispatch("guest/GetGuest", guestId)
        .then((res) => {
          this.succeeed = true;

          this.guest = res.data;
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
          console.log(err);
        });
    },
  },
  created() {
    this.getGuest();
  },
};
</script>
